export default "__VITE_ASSET__DTJW1i$H__"